"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.esriBaseMapNames = exports.defaultBaseMaps = exports.TileLayerExtended = void 0;
const Tile_1 = __importDefault(require("ol/layer/Tile"));
const OSM_1 = __importStar(require("ol/source/OSM"));
const XYZ_1 = __importDefault(require("ol/source/XYZ"));
class TileLayerExtended extends Tile_1.default {
    constructor(props) {
        super(props);
    }
}
exports.TileLayerExtended = TileLayerExtended;
exports.defaultBaseMaps = [
    {
        id: 'openStreetMap',
        label: 'OpenStreetMap',
        isEsri: false,
        isWorldWide: true,
        source: new OSM_1.default({
            attributions: OSM_1.ATTRIBUTION,
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'imagery',
        label: 'Imagery',
        isEsri: true,
        isWorldWide: true,
        esriServiceName: 'World_Imagery',
        source: new XYZ_1.default({
            url: '//server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'topography',
        label: 'Topography',
        isEsri: true,
        isWorldWide: true,
        esriServiceName: 'World_Topo_Map',
        source: new XYZ_1.default({
            url: '//server.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
            attributions: 'Fetching from server...',
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'ocean',
        label: 'Ocean',
        isEsri: true,
        isWorldWide: true,
        esriServiceName: 'Ocean_Basemap',
        source: new XYZ_1.default({
            url: '//server.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'physical',
        label: 'Physical',
        isEsri: true,
        isWorldWide: true,
        source: new XYZ_1.default({
            url: '//server.arcgisonline.com/arcgis/rest/services/World_Physical_Map/MapServer/tile/{z}/{y}/{x}',
            attributions: "Source: US National Park Service",
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'shadedRelief',
        label: 'Shaded relief',
        isEsri: true,
        isWorldWide: true,
        source: new XYZ_1.default({
            url: '//server.arcgisonline.com/arcgis/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
            attributions: "Copyright:(c) 2014 Esri",
            crossOrigin: 'anonymous'
        })
    },
    {
        id: 'lmTopo',
        label: 'LM Topo',
        isEsri: false,
        isWorldWide: false,
        source: new XYZ_1.default({
            url: `//maps.fieldsites.se/lm/open/topowebb-ccby/v1/wmts/1.0.0/topowebb/default/3857/{z}/{y}/{x}.png`
        })
    },
    {
        id: 'lmTopoGray',
        label: 'LM Topo gray',
        isEsri: false,
        isWorldWide: false,
        source: new XYZ_1.default({
            url: `//maps.fieldsites.se/lm/open/topowebb-ccby/v1/wmts/1.0.0/topowebb_nedtonad/default/3857/{z}/{y}/{x}.png`
        })
    }
];
exports.esriBaseMapNames = exports.defaultBaseMaps.filter(bm => bm.esriServiceName).map(bm => bm.esriServiceName);
